<app-dropdown-login-request *ngIf="user && !user.id"></app-dropdown-login-request>
<div class="messages d-flex justify-content-center align-items-center" *ngIf="user && user.id && followUpdates">
    <div class="d-flex justify-content-center align-items-center no-content" *ngIf="!followUpdates.length">
        <h5 style="line-height: 43px">暂无内容</h5>
    </div>

    <div class="scroll-bar w-100" *ngIf="followUpdates.length">
        <div *ngFor="let item of followUpdates">
            <ng-container [ngSwitch]="item.actType">
                <div class="message" *ngSwitchCase="4">
                    <div (click)="msgClick(item)" class="w-100">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light">
                                    您关注的
                                    <span class="name-color" (click)="nameClick($event)">
                                        <a [routerLink]="['/space/', item.uidStr]">
                                            {{item.nickName}}
                                        </a>
                                    </span> 发布了新的剧集
                                    <span class="main-color film-title"
                                        title="{{item.lidName}}">《{{(item.lidName.length>22)?(item.lidName |
                                        slice:0:21)+'...':item.lidName}}》</span>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message" *ngSwitchCase="5">
                    <div (click)="msgClick(item)" class="w-100">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light">
                                    您关注的
                                    <span class="name-color" (click)="nameClick($event)">
                                        <a [routerLink]="['/space/', item.uidStr]">
                                            {{item.nickName}}
                                        </a>
                                    </span> 发布了新的小视频
                                    <span class="main-color film-title"
                                        title="{{item.lidName}}">《{{(item.lidName.length>22)?(item.lidName |
                                        slice:0:21)+'...':item.lidName}}》</span>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message" *ngSwitchCase="3">
                    <div (click)="msgClick(item)" class="w-100">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light">
                                    <span class="name-color">{{item.nickName}}</span> 关注了您！
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message" *ngSwitchCase="6">
                    <div (click)="navToActivity(item)" class="w-100" *ngIf="item.cid === 7 || item.cid === 8">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light activityHeight">
                                    您关注的
                                    <span class="name-color" (click)="nameClick($event)">
                                        <a [routerLink]="['/space/', item.uidStr]">
                                            {{item.nickName}}
                                        </a>
                                    </span> 发布了新的{{ item.other === '小视频' ? '动态小视频' : '动态' }}：
                                    <div class="activity-text" [innerHtml]="textAbstrc(item.lidName)">
                                    </div>
                                    <div class="activity-image d-flex">
                                        <div class="img-ctn"
                                            *ngFor="let pic of item.photoURLs | slice:0:4; let last = last">
                                            <img [src]="pic + '?w=216&h=216&mode=crop'">
                                            <div class="multi-img-shadow" *ngIf="last && item.photoURLs.length > 4">
                                                <span class="multi-img-remain">+ {{ item.photoURLs.length - 4 }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                    <div (click)="msgClick(item)" class="w-100" *ngIf="!(item.cid === 7 || item.cid === 8)">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light">
                                    您上传的<span class="main-color title-2"
                                        title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                                        slice:0:21)+'...':item.lidName}}》</span>有新的评论！
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message" *ngSwitchCase="20">
                    <div (click)="navToAlbum(item)" class="w-100">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light activityHeight">
                                    您关注的
                                    <span class="name-color" (click)="nameClick($event)">
                                        <a [routerLink]="['/space/', item.uidStr]">
                                            {{item.nickName}}
                                        </a>
                                    </span> 发布了新的相册：
                                    <div class="activity-text" [innerHtml]="textAbstrc(item.lidName)">
                                    </div>
                                    <div class="activity-image d-flex">
                                        <div class="img-ctn">
                                            <img [src]="item.other + '?w=216&h=216&mode=crop'">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message" *ngSwitchCase="21">
                    <div (click)="item.cid === 8 ? navToActivity(item) : navToAlbum(item)" class="w-100">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light">
                                    您发布的<span class="main-color title-2"
                                        title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                                        slice:0:21)+'...':item.lidName}}》</span>有新的评论！
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="dropdown-footer d-flex align-items-center">
    <div class="d-flex align-items-center jbutton jbutton-default" [ngClass]="{'disabled': !followUpdates.length}"
        (click)="clearFollowUpdates()">
        <span class="iconfont iconshanchu"></span>
        <span>清空</span>
    </div>
    <a [routerLink]="['/user/follows']" class="d-flex align-items-center jbutton jbutton-default ml-auto">
        <span>我的关注</span>
        <span class="iconfont iconchakangengduo fs-16"></span>
    </a>
</div>